export const GroupIcon = ({ color = '#343330' }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill={color}
      d="M3.313 14.875a.937.937 0 0 1-.938.938H1.75A1.563 1.563 0 0 1 .188 14.25v-.625a.938.938 0 0 1 1.875 0v.313h.312a.94.94 0 0 1 .938.937m3.437-.937H5.5a.938.938 0 0 0 0 1.874h1.25a.938.938 0 0 0 0-1.874m-5.625-2.5a.94.94 0 0 0 .938-.938V9.25a.937.937 0 1 0-1.876 0v1.25a.94.94 0 0 0 .938.938m10 1.25a.94.94 0 0 0-.937.937v.313h-.313a.938.938 0 0 0 0 1.874h.625a1.563 1.563 0 0 0 1.563-1.562v-.625a.94.94 0 0 0-.938-.937m0-5.626a.937.937 0 0 0 .938-.937V5.5A1.563 1.563 0 0 0 10.5 3.938h-.625a.937.937 0 1 0 0 1.874h.313v.313a.94.94 0 0 0 .937.938m-8.75-3.125H1.75A1.56 1.56 0 0 0 .188 5.5v.625a.937.937 0 1 0 1.875 0v-.312h.312a.937.937 0 1 0 0-1.875M14.25.188H5.813A1.56 1.56 0 0 0 4.25 1.75v3.172a.94.94 0 0 0 .938.89H6.75a.937.937 0 1 0 0-1.875h-.625V2.064h7.813v7.812h-1.876V9.25a.938.938 0 0 0-1.874 0v1.563a.94.94 0 0 0 .937.937h3.125a1.563 1.563 0 0 0 1.563-1.562V1.75A1.563 1.563 0 0 0 14.25.188"
    />
  </svg>
)
